import { render } from "./DropDown.vue?vue&type=template&id=1faa4947&scoped=true"
import script from "./DropDown.vue?vue&type=script&lang=js"
export * from "./DropDown.vue?vue&type=script&lang=js"

import "./DropDown.vue?vue&type=style&index=0&id=1faa4947&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1faa4947"]])

export default __exports__